import { DialogContentText, FormHelperText, MenuItem, Select } from '@mui/material'
import Box from '@mui/material/Box'
import { GenericDialog, MButton } from 'components'
import { color } from 'config/color'
import { useMemo } from 'react'

export const UnlinkConfirmDialog = ({
  open,
  isLoading,
  onClose,
  onConfirm,
  accountNumber,
  setAccountNumber,
  primaryAccountId,
  linkedAccounts = []
}: any): JSX.Element => {
  const filteredLinkedAccounts = useMemo(() => {
    return linkedAccounts.filter((la: any) => la.accountId !== primaryAccountId)
  }, [linkedAccounts, primaryAccountId])
  return (
    <Box>
      <GenericDialog
        open={open}
        onClose={onClose}
        isLoading={isLoading}
        title="Unlink Account"
        iconType="warning"
      >
        <Box>
          {filteredLinkedAccounts.length > 0 && (
            <DialogContentText sx={{ mb: 2 }}>
              Please select the account number you want to unlink.
            </DialogContentText>
          )}

          {filteredLinkedAccounts.length === 0
            ? (
              <FormHelperText sx={{ marginBottom: 2, color: color.error[500], fontSize: 15, textAlign: 'center', width: '100%' }}>
                No linked accounts available to unlink.
              </FormHelperText>
            )
            : (
              <Select
                name="accountNumber"
                value={accountNumber}
                displayEmpty
                fullWidth
                sx={{
                  marginBottom: 2,
                  color: color.grey[700]
                }}
                onChange={(e) => {
                  setAccountNumber(e.target.value)
                }}
              >
                <MenuItem value="" disabled>
                  <Box component="span" sx={{ color: color.grey[500] }}>
                    Select an account
                  </Box>
                </MenuItem>
                {filteredLinkedAccounts.map((la: any) => (
                  <MenuItem key={la.accountId} value={la.accountId}>
                    <Box display="flex" flexDirection="column">
                      <Box sx={{ fontWeight: 500 }}>{la.accountId}</Box>
                      <Box sx={{ fontSize: 12, color: color.grey[600] }}>
                        {la.serviceAddress}
                      </Box>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            )}

          {filteredLinkedAccounts.length > 0 && (
            <Box display="flex" flexDirection="row" gap={1}>
              <MButton
                variant="contained"
                type="button"
                size="large"
                rounded="true"
                fullWidth
                onClick={onConfirm}
                texttransform="none"
                disabled={Boolean(isLoading) || accountNumber === '' || filteredLinkedAccounts.length === 0}
                loading={isLoading}
              >
                Yes, unlink account
              </MButton>
              <MButton
                variant="outlined"
                type="button"
                size="large"
                rounded="true"
                fullWidth
                onClick={onClose}
                texttransform="none"
                disabled={isLoading}
              >
                No, keep my account
              </MButton>
            </Box>
          )}
        </Box>
      </GenericDialog>
    </Box>
  )
}
